module.exports = __webpack_public_path__ + "static/media/copilot_publish.de3f8357.png";